import { ColorEnum } from '@enum/style/color.enum';

import { SwitchStyleType } from './switch.style-type';

export const SwitchDarkTheme: SwitchStyleType = {
  colorPrimary: ColorEnum.Teal100,
  colorPrimaryHover: ColorEnum.Teal100,
  colorTextQuaternary: ColorEnum.Black70,
};
